import {
  Button,
  Icon,
  Image,
  StackProps,
  Text,
  VStack,
} from "@chakra-ui/react";
import { RiArrowRightDoubleLine } from "@remixicon/react";
import { useNavigate } from "react-router-dom";
import { getCookie } from "typescript-cookie";
import { capitalizeFirstLetter } from "../utils/helperFunction";

interface Props extends StackProps {
  children?: any;
  userType: string;
}

export const ProtectedRoute = ({ children, userType, ...rest }: Props) => {
  const buyerToken = getCookie(`${userType}Token`);
  const navigate = useNavigate();

  const handleClick = () => {
    if (userType === "buyer") {
      navigate("/login", { replace: true });
    } else if (userType === "reseller") {
      navigate("/login?type=reseller", { replace: true });
    } else if (userType === "supplier") {
      navigate("/login?type=supplier", { replace: true });
    }
  };

  if (!buyerToken) {
    return (
      <VStack w={"100%"} h={"100dvh"} gap={0} justify={"center"} {...rest}>
        <Image
          w={"100%"}
          maxW={"350px"}
          src="/assets/svg/illustration_secure.svg"
        />

        <Text fontSize={[32, null, 34]} fontWeight={"semibold"}>
          Login dulu dong bwangg!
        </Text>

        <Text fontSize={[14, null, 16]} variant={"secondary"}>
          {`Kamu harus login dulu ke akun ${capitalizeFirstLetter(userType)}`}
        </Text>

        <Button
          mt={4}
          variant={"ghost"}
          colorScheme="red"
          size={["xs", null, "sm"]}
          onClick={handleClick}
          rightIcon={<Icon as={RiArrowRightDoubleLine} />}
        >
          {`Login Akun ${capitalizeFirstLetter(userType)}`}
        </Button>
      </VStack>
    );
  }

  return children;
};
